module.exports = __webpack_public_path__ + "img/bold-document-copy.c6bfe053.svg";